import React, { useState } from "react";
import { Link } from "react-router-dom";

import Lightbox from "yet-another-react-lightbox";
import HighlightBlock from "./HighlightBlock";

export const PortfolioGallery = ({
    slides = [],
    onCardClick,
    gridClassName = "gallery",
    cardClassName = "items",
    imageClassName = "img",
    showDescription = false,
    showTitle = false,
    lightboxProps = { className: "light-box" },
    highlightBlockProps
}) => {
    const [open, setOpen] = useState(false);
    const [index, setIndex] = useState(0);

    const handleClick = (i) => {
        setOpen(true);
        setIndex(i);
        onCardClick?.(slides[i], i);
    };

    return (
        <div className="container">
            <HighlightBlock {...highlightBlockProps}>
                <div className="works">
                    <div className={gridClassName}>
                        {slides.map((slide, i) => (
                            <div
                                key={slide.id || i}
                                className={cardClassName}
                                onClick={() => handleClick(i)}
                            >
                                <div className="item">
                                    <div className={imageClassName}>
                                        <img src={slide.thumb || slide.image} alt={slide.title} loading="lazy" />
                                    </div>
                                    {(showTitle || showDescription) && (
                                        <div className="cont">
                                            {showTitle && slide.title && <h5>{slide.title}</h5>}
                                            {showDescription && slide.description && <span>{slide.description}</span>}
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <Lightbox
                        open={open}
                        close={() => setOpen(false)}
                        index={index}
                        slides={slides.map(slide => ({
                            src: slide.imageG || slide.image,
                            alt: slide.title,
                        }))}
                        {...lightboxProps}
                    />
                </div>
            </HighlightBlock>
        </div>
    );
};

export default PortfolioGallery;
